import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual, TLDR, rand} from '../common';

const headers = [
  ["We rise together, or we all die alone.", 
    null],
  ["Nos alzamos juntos o morimos todos solitos.",
    null],
  ["우리는 함께 일어나거나, 아니면 모두 혼자 죽는다.",
    "Ulineun hamkke il-eonageona, animyeon modu honja jugneunda."],
  ["我们要么共同崛起，要么孤独地死去。",
    "Wǒmen yàome gòngtóng juéqǐ, yàome gūdú de sǐqù."],
  ["Við rísum saman eða deyjum öll ein.",
    null],
  ["נקום יחד, או שכולנו נמות לבד.",
    "Nekum yehad, o shkolnu nimot leved."],
  ["ننهض معًا، أو نموت جميعًا وحدنا.",
    "Nanhid mean, 'aw numut jmyean wahdana."],
  ["Мы восстанем вместе, или все умрем в одиночку.",
    "My vosstanem vmeste, ili vse umrem v odinochku."],
  ["Powstaniemy razem albo umrzemy sami.",
    null],
  ["We be awesome together, or we all go splat each in his own cave.",
    null],
];

var choice = rand(0, headers.length - 1);

// Nos alzamos juntos o morimos todos solitos
export const die_alone = {
  name: "together",
  alternatives: "die alone",
  header: <span>
    {headers[choice][0]}{headers[choice][1] && <sup>†</sup>}
  </span>,
  headerFootnote: (!headers[choice][1]) ? null : <span>† {headers[choice][1]}</span>,
  outside: (choice == 0) ? null : <span>Translation to <PL>English</PL>: we rise together, or we all die alone.</span>,
  preview: <div className="angle-preview">
    <p><PL>Individuality</PL> is just an <NW>illusion</NW>. <NW word="authenticity">Barántúlacht</NW> is not.</p>
    <p><QL name="integration">融入不是抹去</QL> if we are <i><QL name="consciousness">conscious</QL></i> about it: not just <QL>RigidBoxing</QL><sup>™</sup> ourself to ‘<PL name="comfort">blissful</PL>’ oblivion (<NW word="heatdeath">heat death</NW>).</p>
  </div>,
  text: <div className="angle-text">
    <p>A main difference between <QL>consciousness</QL> and ‘<LRL name="reactivity.">nature</LRL>’ is that if you throw bicarb and vinegar (or matter and antimatter) in a vat together, they can’t <i>help</i> but combne and <i>react</i>. If you throw Hegel’s thesis and antithesis into a jar, there need not be nuclear war. There can be a synthesis that maintains parts of both, by <i><LRL>understanding</LRL></i> and realises that we’re in this together – against an <AL name="war">enemy</AL> that’s not even <i>thinking</i> like we are.</p>
    <p>If <NW>God</NW> is <PL>non-finite</PL>, the <LRL name="nepantla.">CT</LRL> proves that It’s the <LRL>imagination</LRL>.</p>
    <p>Before <AL name="haste">jumping</AL> to conclusions, let’s <QL name="pg.">know</QL> <PL>ourself</PL>, first.</p>
  </div>,
};

